import { createAction } from '@reduxjs/toolkit';

export const listSectionsStart = createAction('LIST_SECTIONS::START');
